module.exports = __webpack_public_path__ + "img/kolor-6-15.f5ef9b9e.jpg";